import { signalSourceMap, type SignalSource } from "app/pages/sales-intelligence/domain/signals/types/signal";

export const getPlaybookSignalSource = (isSharedWithAccount: boolean): SignalSource =>
    isSharedWithAccount ? signalSourceMap.account : signalSourceMap.platform;
